import React from 'react';
export function Footer() {
  return <footer className="bg-[#0B2545] border-t-4 border-[#0A7D79] py-10 px-4 text-center" data-id="element-137" data-mp="32wd2qgad7ltj">
      <p className="text-xs text-white/60 max-w-3xl mx-auto mb-4 leading-relaxed" data-id="element-138" data-mp="3ggtymjf7hl5r">
        Educational teaching-support material for nursing instructors, clinical faculty, nurse educators and nursing
        program instructors. It does not replace an accredited nursing curriculum, licensure requirements, current
        clinical guidelines, local regulations or qualified clinical supervision, and it is not medical advice for
        patients. Results depend on each instructor, student and training context; no specific results are guaranteed.
      </p>
      <p className="text-sm text-white/80" data-id="element-139" data-mp="3qcxbokblj47h">© Nursing Instructor Atlas 2026 — All Rights Reserved.</p>
    </footer>;
}